// ─────────────────────────────────────────────────────────────
// LukaDuka - Server Reachable check (ver1)
// One quick question: can LukaDuka's server be reached right now?
//
// ver1 - 2 November 2026 (Offline Capture screen - Layer 2c):
//   - A single tiny HEAD request to the Supabase REST root, with a hard
//     time limit. Same test the app's heartbeat (useOnlineStatus) uses:
//     any direct answer (200 / 401 / 404) means the server is reachable.
//   - Used by Router at start-up (3s limit) and, from Layer 4, by the
//     Offline Capture screen to notice when the connection is back.
//   - Never throws. Missing configuration counts as "reachable" so a
//     developer setup never gets stuck on the offline screen.
//
// Path: src/app/offline/serverReachable.ts
// ─────────────────────────────────────────────────────────────

export async function isServerReachable(timeoutMs: number): Promise<boolean> {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined
  if (!url || !anonKey) return true

  const controller = new AbortController()
  const timer = window.setTimeout(() => controller.abort(), timeoutMs)

  try {
    const response = await fetch(`${url}/rest/v1/`, {
      method: 'HEAD',
      headers: { apikey: anonKey },
      signal: controller.signal,
      cache: 'no-store',
    })
    return response.ok || response.status === 401 || response.status === 404
  } catch {
    return false
  } finally {
    window.clearTimeout(timer)
  }
}
